// extracted by mini-css-extract-plugin
export default {"section":"OurVision_section__FKwLA","paragraph2":"OurVision_paragraph2__fkLeB"};